import { render, staticRenderFns } from "./CCMObservationAdd.vue?vue&type=template&id=03400806"
import script from "./CCMObservationAdd.vue?vue&type=script&lang=js"
export * from "./CCMObservationAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports